import request from '@host-panel/request';

type RequestPayload = {
  eventId: string;
};

type Response = {
  id: string;
};

export function deleteLiveBlog({ eventId }: RequestPayload): Promise<Response> {
  return request(`/host-panel/live-blog/event/${eventId}`, {
    method: 'DELETE'
  });
}
